<template>
    <div>
        <b-form @submit.prevent="submit">
            <div class="input-grid">
                <b-form-input
                    v-model="email"
                    type="email"
                    :placeholder="$t('login.emailLabel')"
                    autocomplete="email"
                ></b-form-input>
                <b-form-input
                    v-model="password"
                    type="password"
                    :placeholder="$t('login.passwordLabel')"
                    autocomplete="password"
                ></b-form-input>
            </div>
            <div class="text--error mb-3" v-if="errorMessage">
                {{ errorMessage }}
            </div>
            <b-button block type="submit" variant="primary" @submit.prevent="submit">
                {{ $t('login.loginButton') }}
                <b-spinner small v-if="loading"></b-spinner>
            </b-button>
            <b-button block @click="forgotPassword">
                {{ $t('login.forgotPasswordButton') }}
            </b-button>
        </b-form>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import AlignRight from '@components/Layout/AlignRight.vue';
import { api } from "@services/AxiosBootstrap";

export default defineComponent({
    components: { AlignRight },
    data() {
        return {
            user: null,
            password: null,
            email: null,
            errorMessage: null,
            loading: false,
        };
    },
    methods: {
        handleUpdate(event) {
            this.$emit('update', event);
        },
        forgotPassword() {
            this.$router.push({ path: `/account/forgot-password` });
        },
        async submit() {
            this.loading = true;
            try {
                const response = await api.post('/auth/login', {
                    email: this.email,
                    password: this.password,
                });

                if (response.status === 200) {
                    const data = response.data.data;
                    this.handleUpdate({user: data.user, auth: data.auth });
                }
            } catch (e) {
                console.log(e.response.data.status);
                this.errorMessage = e.response.data.message;
            }
            this.loading = false;
        },
    },
});
</script>
<style scoped>
.input-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    margin: 1rem 0;
}
.text--error {
    color: red;
}
</style>
